import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";

export interface PosterConfig {
  id: number;
  left: number; 
  top: number; 
  width: number; 
  height: number; 
}

export const posterConfigs: PosterConfig[] = [
  { id: 1, left: 0.0, top: 0.0, width: 0.12, height: 0.4 },
  { id: 2, left: 0.16, top: 0.20, width: 0.08, height: 0.25 },
  { id: 3, left: 0.45, top: 0.08, width: 0.04, height: 0.10 },
  { id: 4, left: 0.64, top: 0.05, width: 0.05, height: 0.12 },
  { id: 5, left: 0.82, top: 0.05, width: 0.12, height: 0.28 },
  { id: 6, left: 0.92, top: 0.20, width: 0.08, height: 0.30 },
];

function setPosition(element: HTMLElement, binding: DirectiveBinding) {
  const config = binding.value as PosterConfig;
  
  if (!config) return;

  element.style.position = "fixed";
  element.style.left = window.innerWidth * config.left + "px";
  element.style.top = window.innerHeight * config.top + "px";
  element.style.width = window.innerWidth * config.width + "px";
  element.style.height = window.innerHeight * config.height + "px";
  element.style.cursor = "pointer";
  element.style.zIndex = "10";
  // Transparent background - no image displayed
  element.style.backgroundColor = "transparent";
  // Debugging border
  // element.style.border = "1px dashed rgba(255, 0, 0, 0.3)";
}

const posterDirective: DirectiveOptions = {
  inserted(el, binding) {
    setPosition(el, binding);
  },
  update(el, binding) {
    setPosition(el, binding);
  }
};

export default posterDirective;
